import snsAxiosClient from '../common/http/http-sns';

function getAllCancelledItems(environmentVariables, user) {
  const options = {
    headers: {
      ...environmentVariables.API_HEADERS_GET_V1,
      Authorization: `Bearer ${user.authToken}`,
    },
  };

  return snsAxiosClient(options).get(
    `${environmentVariables.SNS_CANCELED_ITEMS_API}${user.UUID}/cancelledSubscriptions`,
  );
}

export default getAllCancelledItems;
